import { Component, OnInit, ViewChild } from '@angular/core'
import { ConfirmationService, LazyLoadEvent } from 'primeng/api'
import { Table } from 'primeng/table'
import { Subject, Subscription } from 'rxjs'
import { debounceTime } from 'rxjs/operators'
import { AuthManager } from '../shared/auth/AuthManager'
import { ApplicationArea, AppPractice, AuthApiClient, ClientInfo, EscheatmentApiClient } from '../shared/services/ppv.api'

@Component({
   selector: 'app-escheatment',
   templateUrl: './escheatment.component.html',
   styleUrls: ['./escheatment.component.scss'],
   standalone: false,
})
export class EscheatmentComponent implements OnInit {
   public mainLoading = true
   public tableLoading = 0
   public pageSize = 200
   public practices: AppPractice[] = []
   public selectedPractice: AppPractice

   public rows: ClientInfo[] = []

   @ViewChild('dt') private table: Table

   pageRequested = new Subject<LazyLoadEvent>()

   subscriptions: Subscription[] = []

   constructor(
      private escheatmentService: EscheatmentApiClient,
      private authManager: AuthManager,
      private authApiClient: AuthApiClient,
      private confirmationService: ConfirmationService
   ) {}

   public loadData(event: LazyLoadEvent) {
      this.tableLoading++

      console.log('load event triggered', JSON.stringify(event))

      this.escheatmentService
         .listClientsWithCredit({
            offset: event.first,
            rows: event.rows,
            practice: this.selectedPractice?.id ?? 0,
            sortOrder: event.sortOrder,
            sortField: event.sortField,
         })
         .subscribe((results) => {
            if (this.rows.length != results.totalLength) {
               this.rows = Array.from({ length: results.totalLength })
            }

            Array.prototype.splice.apply(this.rows, [...[event.first, event.rows], ...results.data])

            this.rows = [...this.rows]

            this.tableLoading--
         })
   }

   public clickTest() {
      this.rows = []
      setTimeout(() => {
         this.table.reset()
      }, 100)
   }

   ngOnInit(): void {
      this.mainLoading = true
      this.subscriptions.push(
         this.pageRequested
            //.pipe(debounceTime(200))
            .subscribe((newPage) => this.loadData(newPage))
      )

      this.authManager.getCurrentUser().subscribe((user) => {
         this.authApiClient.getActivePractices(ApplicationArea.Escheatment).subscribe((ap) => {
            this.practices = user.practices.filter((p) => ap.indexOf(p.id) > -1).sort((x, y) => x.nameId.localeCompare(y.nameId))

            this.mainLoading = false
         })
      })
   }

   onFilterPractice(event) {
      this.resetTable()
      this.table.filter(event.value.id, 'practiceSkey', 'eq')
   }

   resetTable() {
      this.rows = []
      this.table.resetScrollTop()
      // this.table.clearCache();
   }

   confirm(rowIndex: number, clientInfo: ClientInfo, isRefunded: boolean) {
      this.confirmationService.confirm({
         message: 'I confirm I have adjusted this balance in my practice management system.',
         accept: () => {
            console.log('Confirmed!')
            this.tableLoading++
            this.subscriptions.push(
               this.escheatmentService
                  .storeEscheatment({
                     isRefunded: isRefunded,
                     practiceSkey: clientInfo.practiceSkey,
                     balance: clientInfo.balance,
                     origSourceSkey: clientInfo.origSourceSkey,
                  } as any)
                  .subscribe(() => {
                     this.rows.splice(rowIndex, 1)
                     this.rows = [...this.rows]
                     this.tableLoading--
                  })
            )
         },
      })
   }

   ngOnDestroy() {
      for (const sub of this.subscriptions) {
         sub.unsubscribe()
      }
   }
}
